import UserThumbnail from '@atom/components/common/UserThumbnail';
import { useNavigation } from '@atom/hooks/useNavigation';
import { List } from '@atom/mui';
import colors from '@atom/styles/colors';
import { UserResult } from '@atom/types/search';
import { highlightedText } from '@atom/utilities/textDisplayUtilities';

import classes from './searchPortal.module.css';

const { ListItemButton, ListItem, ListItemText } = List;

const style = {
  listItem: {
    padding: 0,
    margin: 0,
    borderBottom: `1px solid ${colors.neutral.typhoon}`,
  },
  listItemButton: {
    height: '3.5rem',
  },
};

interface Props {
  query: string;
  user: UserResult;
}

const UserResultRow = ({ query, user }: Props) => {
  const [, { navigate }] = useNavigation();
  const name = highlightedText(query, `${user.firstName} ${user.lastName}`);
  const emailAddress = highlightedText(query, user.email);

  return (
    <ListItem style={style.listItem} key={user.id} disablePadding>
      <ListItemButton
        disableGutters
        onClick={() => navigate(`/team/${user.id}`)}
        style={style.listItemButton}
      >
        <div className={classes.iconContainerUser}>
          <UserThumbnail image={user.photoUrl} />
        </div>
        <ListItemText
          disableTypography
          primary={
            <div>
              <div>{name}</div>
              <div className={classes.emailSubtext}>{emailAddress}</div>
            </div>
          }
        />
      </ListItemButton>
    </ListItem>
  );
};

export default UserResultRow;
